import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { message } from 'antd';
import FormReservationsConfigResto from '../../components/FormReservationsConfigResto';
import { getRestaurant, getIsSavingRestaurant, getErrorRestaurant, getIsSavedRestaurant } from '../../reducers';
import { setReserveConfigurationsToRestaurant, setSavedRestaurant } from '../../actions/setReserveConfigurationsToRestaurant';
import LoadingPage from '../../components/LoadingPage';
import { Grid, Row, Col } from 'react-flexbox-grid';
import ReservationsConfigResto from '../../components/ReservationsConfigResto';

const listAverageReservationTime = { 
    "30": "30min",
    "60": "1h",
    "90": "1h 30min",
    "120": "2h",
    "150": "2h 30 min",
    "180": "3h",
    "210": "3h 30min",
    "240": "4h",
};

const listPreviousCancellationTime = {
    "60": "1h",
    "120": "2h",
    "180": "3h",
    "240": "4h",
    "300": "5h",
    "360": "6h",
    "420": "7h",
    "480": "8h",
    "540": "9h",
    "600": "10h",
    "660": "11h",
    "720": "12h",
};

class ReservationsConfiguration extends Component {
    state = {
        isEditingReservationsConfig: false,
    }

    onSubmit = values => {
        this.saveData(values);
    }

    saveData = (values) => {
        const { restaurant } = this.props;
        this.props.setReserveConfigurationsToRestaurant({
            id: restaurant.id,
            totalCapacity: values.field_total_capacity,
            reservationCapacity: values.field_reservation_capacity,
            automaticReservations: values.field_automatic_reservations,
            minPlacesPerReservation: values.field_min_places_per_reservation,
            maxPlacesPerReservation: values.field_max_places_per_reservation,
            averageReservationTime: parseInt(values.field_average_reservation_time),
            minimumPreviousReservationHours: values.field_minimum_previous_reservation_hours,
            maximumPreviousReservationDays: values.field_maximum_previous_reservation_days,
            reservePreviousCancellationTime: parseInt(values.field_reserve_previous_cancellation_time),
        });
    }

    onEditReservationsConfig = () => {
        this.setState({ isEditingReservationsConfig: true });
    }

    handleExitEdition = () => {
        this.setState({ isEditingReservationsConfig: false });
    }

    renderSavedRestaurant = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedRestaurant = false;
        this.props.setSavedRestaurant(isSavedRestaurant);
        this.setState({ isEditingReservationsConfig: false });
        return;
    }

    render() {
        const { restaurant, isSavingRestaurant, isSavedRestaurant } = this.props;
        return (
            <div>
                {
                    restaurant ?
                        <div>
                            <Grid>
                                <Row>
                                    <Col xs={12}>
                                        {
                                            this.state.isEditingReservationsConfig ?
                                                <FormReservationsConfigResto restaurant={restaurant} onExit={this.handleExitEdition} onSubmit={this.onSubmit} isSaving={isSavingRestaurant} listAverageReservationTime={listAverageReservationTime} listPreviousCancellationTime={listPreviousCancellationTime}/>
                                                :
                                                <ReservationsConfigResto restaurant={restaurant} onEditConfigResto={this.onEditReservationsConfig} listAverageReservationTime={listAverageReservationTime} listPreviousCancellationTime={listPreviousCancellationTime}/>
                                        }
                                    </Col>
                                </Row>
                            {
                                isSavedRestaurant && this.renderSavedRestaurant()
                            }
                            </Grid>
                        </div>
                        :
                        <LoadingPage />

                }
            </div>
        );
    }
}

ReservationsConfiguration.propTypes = {
    restaurant: PropTypes.object,
    isSavingRestaurant: PropTypes.bool.isRequired,
    isSavedRestaurant: PropTypes.bool.isRequired,
    errorRestaurant: PropTypes.object.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setReserveConfigurationsToRestaurant: value => dispatch(setReserveConfigurationsToRestaurant(value)),
    setSavedRestaurant: value => dispatch(setSavedRestaurant(value)),
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
    isSavedRestaurant: getIsSavedRestaurant(state),
    isSavingRestaurant: getIsSavingRestaurant(state),
    errorRestaurant: getErrorRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ReservationsConfiguration));